module.exports = "<emi-top-nav></emi-top-nav>\r\n<router-outlet (deactivate)=\"onDeactivate()\"></router-outlet>\r\n<emi-footer></emi-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/base-app/base-app.component.html
// module id = 680
// module chunks = 8